<template>
  <div class="onboarding-static-page-container">
      <OnboardingMenu class="menu" :logo="logoUrl" :languages="languageOptions" :menus="menuOptions"></OnboardingMenu>
      <div class="header">
        <p>{{ $t('onboarding.nestle.myFirstDayPageHK.title') }}</p>
      </div>
      <div class="body">
        <div class="text-board clear-margin-top">
          <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageHK.hk') }}</p>
          <p class="board-subtitle">{{ $t('onboarding.nestle.myFirstDayPageHK.information') }}</p>
        </div>
        <div class="image-board clear-margin-top" @click="toOutSide('https://www.nestle.com.hk/')">
            <img :src="firstImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageHK.hkWebSite') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board flex-derection-row-reverse" @click="toOutSide('https://www.nestle.com.hk/aboutus/brandstory')">
            <img :src="secondImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageHK.story') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="image-board" @click="toOutSide('https://www.nestle.com.hk/info/address')">
            <img :src="thirdImgUrl" alt="">
            <div class="content">
              <p class="board-title">{{ $t('onboarding.nestle.myFirstDayPageHK.hkOffice') }}</p>
              <p class="board-subtitle"></p>
            </div>
        </div>
        <div class="follow">
          <p v-html="$t('onboarding.nestle.followUs')"></p>
          <p>{{ $t('onboarding.nestle.donnotBeShared') }}</p>
        </div>
      </div>
      <Footer></Footer>
  </div>
</template>

<script>
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'
import OnboardingMenu from '@/components/onboarding/form/Menu'
import Footer from '@/components/onboarding/form/Footer'
import { deviceType } from '@/utils/common'

export default {
  mixins: [onboardingMixin],
  components: {
    OnboardingMenu, Footer
  },
  data () {
    const isMobile = deviceType.isMobile
    return {
      firstImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/hk/website.jpg' : '@/assets/image/onboarding/my-first-day/pc/hk/website.jpg'),
      secondImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/hk/story.jpg' : '@/assets/image/onboarding/my-first-day/pc/hk/story.jpg'),
      thirdImgUrl: require(isMobile ? '@/assets/image/onboarding/my-first-day/h5/hkSite.jpg' : '@/assets/image/onboarding/my-first-day/pc/hkSite.jpg')
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/onboarding-common.scss';
@import '@/assets/scss/onboarding-static-page.scss';

.onboarding-static-page-container {
  .header {
    background-image: url('~@/assets/image/onboarding/my-first-day/h5/banner.jpg');
  }
}

/* 中型设备（台式电脑） */
@media (min-width: 769px) {
  .onboarding-static-page-container {
    .header {
      background-image: url('~@/assets/image/onboarding/my-first-day/pc/banner.jpg');
    }
  }
}
</style>
